import React, { useRef, useState } from 'react';
import { ArrowSquareOut, Camera, CircleNotch, Trash } from '@phosphor-icons/react';
import { DialogHuelle, ImmoButton } from '../../../../components/immobilien/ui';
import { kurzDatum, standText } from '../../../../lib/zaehler/liste';
import type { AblesungZeile, ZaehlerDaten } from '../../../../lib/zaehler/useZaehlerDetail';

/** #512: Beleg-Foto einer Ablesung groß ansehen, ersetzen oder entfernen. */
export function FotoAnsicht({ z, ablesung, laeuft, onSchliessen, onErsetzen, onEntfernen }: {
  z: ZaehlerDaten; ablesung: AblesungZeile; laeuft: boolean;
  onSchliessen: () => void; onErsetzen: (datei: File) => void; onEntfernen: () => void;
}) {
  const datei = useRef<HTMLInputElement>(null);
  const [frage, setFrage] = useState(false);
  const url = ablesung.foto_url;
  return (
    <DialogHuelle titel="Foto der Ablesung" untertitel={`${standText(ablesung.wert, z.einheit)} · ${kurzDatum(ablesung.datum)}${ablesung.erfasser ? ` · ${ablesung.erfasser}` : ''}`}
      icon={Camera} onSchliessen={onSchliessen} laeuft={laeuft} breite={760}
      fuss={frage ? (
        <>
          <span className="flex-1" style={{ fontSize: 13, fontWeight: 700, alignSelf: 'center' }}>Foto wirklich entfernen? Die Ablesung bleibt.</span>
          <ImmoButton art="fuellung" groesse={44} onClick={() => setFrage(false)} disabled={laeuft}>Abbrechen</ImmoButton>
          <ImmoButton art="bad" groesse={44} icon={laeuft ? CircleNotch : Trash} onClick={onEntfernen} disabled={laeuft}>Entfernen</ImmoButton>
        </>
      ) : (
        <>
          <input ref={datei} type="file" accept="image/*" className="sr-only" aria-label="Neues Foto wählen"
            onChange={e => { const f = e.target.files?.[0]; e.target.value = ''; if (f) onErsetzen(f); }} />
          {url && <a href={url} target="_blank" rel="noopener noreferrer" className="flex-1"><ImmoButton groesse={44} icon={ArrowSquareOut} style={{ width: '100%' }}>Im Tab öffnen</ImmoButton></a>}
          <ImmoButton groesse={44} icon={laeuft ? CircleNotch : Camera} onClick={() => datei.current?.click()} disabled={laeuft}>Foto ersetzen</ImmoButton>
          <ImmoButton art="bad" groesse={44} icon={Trash} onClick={() => setFrage(true)} disabled={laeuft || !url}>Entfernen</ImmoButton>
        </>
      )}>
      {url ? (
        <img src={url} alt={`Zählerfoto vom ${kurzDatum(ablesung.datum)}`}
          style={{ display: 'block', maxWidth: '100%', maxHeight: '65dvh', margin: '0 auto', borderRadius: 16, objectFit: 'contain', background: 'var(--fill2)' }} />
      ) : (
        <span style={{ fontSize: 13, color: 'var(--ink3)' }}>Kein Foto vorhanden.</span>
      )}
    </DialogHuelle>
  );
}
